//ghj
var ExtendHelper = function() {};
ExtendHelper.register = function(child, parent) {
	if (typeof parent == "function") {
		(function() {
			var Super = function() {};
			Super.prototype = parent.prototype;
			child.prototype = new Super();
			child.prototype.constructor = child;
		})();
	}
	child.extendEx = function(fns, newOnly) {
		if (newOnly) {
			for (var key in fns) {
				if (!child[key]) child[key] = fns[key];
			}
		} else {
			for (var key in fns) {
				child[key] = fns[key];
			}
		}
	};
	child.prototype.extendEx = function(fns, newOnly) {
		if (newOnly) {
			for (var key in fns) {
				if (!child.prototype[key]) child.prototype[key] = fns[key];
			}
		} else {
			for (var key in fns) {
				child.prototype[key] = fns[key];
			}
		}
	};
};

ExtendHelper.register(String);
String.prototype.extendEx({
	repeat: function(count) {
		'use strict';
		if (this == null) {
			throw new TypeError('can\'t convert ' + this + ' to object');
		}
		var str = '' + this;
		count = +count;
		if (count != count) {
			count = 0;
		}
		if (count < 0) {
			throw new RangeError('repeat count must be non-negative');
		}
		if (count == Infinity) {
			throw new RangeError('repeat count must be less than infinity');
		}
		count = Math.floor(count);
		if (str.length == 0 || count == 0) {
			return '';
		}
		if (str.length * count >= 1 << 28) {
			throw new RangeError('repeat count must not overflow maximum string size');
		}
		var rpt = '';
		for (;;) {
			if ((count & 1) == 1) {
				rpt += str;
			}
			count >>>= 1;
			if (count == 0) {
				break;
			}
			str += str;
		}
		return rpt;
	}
}, true);
String.prototype.extendEx({
	toDateTimeEx: function() {
		if (this.length < 19) return null;
		return new Date(this.substr(0, 4), this.substr(5, 2) - 1, this.substr(8, 2), this.substr(11, 2),
			this.substr(
				14, 2), this.substr(17, 2));
	},
	toDateStringEx: function(format) {
		var dateTime = this.toDateTimeEx();
		return dateTime ? dateTime.toStringEx(format) : "";
	},
	padLeftEx: function(totalWidth, paddingChar) {
		if (this.length > totalWidth) return this;
		if (paddingChar == "") paddingChar = " ";
		var text = this;
		for (var i = this.length; i < totalWidth; i++) {
			text = paddingChar + text;
		}
		return text;
	},
	padRightEx: function(totalWidth, paddingChar) {
		if (this.length > totalWidth) return this;
		if (paddingChar == "") paddingChar = " ";
		var text = this;
		for (var i = this.length; i < totalWidth; i++) {
			text = text + paddingChar;
		}
		return text;
	},
	toArrayEx: function() {
		if (this == "") return [];
		var list = this.split(/\r\n|\r|\n|[;；]/g);
		var result = [];
		for (var i = 0; i < list.length; i++) {
			var item = list[i].trim();
			if (item.length > 0) result.push(item);
		}
		return result;
	},
	toThousand: function() {
		if (this.indexOf(".") !== -1) return this.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
		return this.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
	},




});


ExtendHelper.register(Date);
Date.prototype.extendEx({
	// 添加年数
	addYearsEx: function(years) {
		var month = this.getMonth();
		new Date().addYears()
		this.setFullYear(this.getFullYear() + years);
		if (month == this.getMonth()) return this;
		var date = new Date(this.getFullYear(), this.getMonth(), 1);
		date.setDate(0);
		this.setDate(date.getDate());
		this.setMonth(this.getMonth() - 1);
		return this;
	},
	// 添加月数
	addMonthsEx: function(months) {
		var day = this.getDate();
		this.setMonth(this.getMonth() + months);
		if (day == this.getDate()) return this;
		var date = new Date(this.getYear(), this.getMonth(), 1);
		date.setDate(0);
		this.setDate(date.getDate());
		this.setMonth(this.getMonth() - 1);
		return this;
	},
	// 添加天数
	addDaysEx: function(days) {
		this.setDate(this.getDate() + days);
		return this;
	},
	// 转换成字符串
	toStringEx: function(format) {
		format = format.replace("yyyy", this.getFullYear());
		format = format.replace("MM", (this.getMonth() + 1).toString().padLeftEx(2, "0"));
		format = format.replace("dd", this.getDate().toString().padLeftEx(2, "0"));
		format = format.replace("HH", this.getHours().toString().padLeftEx(2, "0"));
		format = format.replace("mm", this.getMinutes().toString().padLeftEx(2, "0"));
		format = format.replace("ss", this.getSeconds().toString().padLeftEx(2, "0"));
		return format;
	},
	toWeekStringEx: function() {
		let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
		let week = weeks[this.getDay()]
		return week;
	}
});

ExtendHelper.register(Array);
Array.prototype.extendEx({
	existsEx: function(predicate) {
		if (this.length == 0) return false;
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) return true;
		}
		return false;
	},
	eachEx: function(callback) {
		if (this.length == 0) return [];
		var result = [];
		for (var i = 0; i < this.length; i++) {
			result.push(this[i]);
			if (callback(i, this[i]) == false) return result;
		}
		return result;
	},
	getValueEx: function(targetProperty, sourceProperty, sourceValue) {
		if (this.length == 0) return null;
		for (var i = 0; i < this.length; i++) {
			if (this[i][sourceProperty] == sourceValue) return this[i][targetProperty];
		}
		return null;
	},
	getByFnEx: function(predicate) {
		if (this.length == 0) return null;
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) return this[i];
		}
		return null;
	},
	findEx: function(predicate) {
		if (this.length == 0) return [];
		var list = [];
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) list.push(this[i]);
		}
		return list;
	},
	findIndexEx: function(predicate) {
		if (this.length == 0) return [];
		var list = [];
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) list.push(i);
		}
		return list;
	},
	indexOfEx: function(item) {
		if (this.length == 0) return -1;
		for (var i = 0; i < this.length; i++) {
			if (this[i] == item) return i;
		}
		return -1;
	},
	indexOfByFnEx: function(predicate) {
		if (this.length == 0) return -1;
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) return i;
		}
		return -1;
	},
	containsEx: function(item) {
		if (this.length == 0) return false;
		for (var i = 0; i < this.length; i++) {
			if (this[i] == item) return true;
		}
		return false;
	},
	containsByFnEx: function(predicate) {
		if (this.length == 0) return false;
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) return true;
		}
		return false;
	},
	anyEx: function(predicate) {
		if (this.length == 0) return false;
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) return true;
		}
		return false;
	},
	countEx: function(predicate) {
		if (this.length == 0) return 0;
		if (!predicate) return this.length;
		var count = 0;
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) count++;
		}
		return count;
	},
	sumEx: function(callback) {
		if (this.length == 0) return 0;
		if (!callback) return 0;
		var total = 0;
		for (var i = 0; i < this.length; i++) {
			total += callback(this[i]);
		}
		return total;
	},
	maxEx: function(callback) {
		if (this.length == 0) return null;
		if (!callback) return null;
		var maxValue = callback(this[0]);
		for (var i = 1; i < this.length; i++) {
			var value = callback(this[i]);
			if (value != null && value > maxValue) maxValue = value;
		}
		return maxValue;
	},
	whereEx: function(callback) {
		if (this.length == 0) return [];
		var result = [];
		for (var i = 0; i < this.length; i++) {
			if (callback(this[i])) result.push(this[i]);
		}
		return result;
	},
	selectEx: function(callback) {
		if (this.length == 0) return [];
		var result = [];
		for (var i = 0; i < this.length; i++) {
			result.push(callback(this[i]));
		}
		return result;
	},
	removeAtEx: function(index) {
		var result = this.splice(index, 1);
		return result.length ? result[0] : null;
	},
	removeEx: function(item) {
		if (this.length == 0) return -1;
		for (var i = 0; i < this.length; i++) {
			if (this[i] == item) {
				return i;
			}
		}
		return -1;
	},
	removeByFnEx: function(predicate) {
		if (this.length == 0) return null;
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) {
				return this.splice(i, 1)[0];
			}
		}
		return null;
	},
	removeAllByFnEx: function(predicate) {
		if (this.length == 0) return [];
		var list = [];
		for (var i = 0; i < this.length; i++) {
			if (predicate(this[i])) {
				list.push(this.splice(i, 1)[0]);
				i--;
			}
		}
		return list;
	},
	insertEx: function(index, item) {
		this.splice(index, 0, item);
		return this.length - 1;
	},
	insertRangeEx: function(index, list) {
		for (var i = 0; i < list.length; i++) {
			this.splice(index + i, 0, list[i]);
		}
		return this.length - 1;
	},
	appendEx: function(item) {
		this.push(item);
		return this.length - 1;
	},
	appendRangeEx: function(list) {
		for (var i = 0; i < list.length; i++) {
			this.push(list[i]);
		}
		return this.length - 1;
	},
	distinctEx: function(predicate) {
		if (!this.length) return [];
		if (this.length == 1) return [this[0]];
		var list = [this[0]];
		for (var i = 1; i < this.length; i++) {
			var item = this[i];
			var only = true;
			for (var j = 0; j < list.length; j++) {
				if (predicate(item, list[j])) {
					only = false;
					break;
				}
			}
			if (only) list.push(item);
		}
		return list;
	},
	groupByEx: function(predicate) {
		var groups = {};
		this.forEach(function(o) {
			var group = JSON.stringify(predicate(o));
			groups[group] = groups[group] || [];
			groups[group].push(o);
		});
		return Object.keys(groups).map(function(group) {
			return groups[group];
		});
	},
	groupEx: function(num) {
		var result = [];
		for (var i = 0; i < this.length; i += num) {
			result.push(this.slice(i, i + num));
		}
		return result;
	}
});
